import Vue from 'vue';
import VueMeta from 'vue-meta';
import vClickOutside from 'v-click-outside';
import VModal from 'vue-js-modal';
import VueWindowSize from 'vue-window-size';
import Notifications from 'vue-notification';
// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// import { Integrations } from '@sentry/tracing';

// eslint-disable-next-line import/no-extraneous-dependencies
import LoadScript from 'vue-plugin-load-script';
import App from './App.vue';
import router from './router';
import store from './store';
import { gaEventEmitter } from './lib/ga';

// if (process.env.VUE_APP_SENTRY_ENV) {
//   Sentry.init({
//     dsn: 'https://983fb195005842da8c43b461c3e790b2@o426174.ingest.sentry.io/5456223',
//     environment: process.env.VUE_APP_SENTRY_ENV,
//     integrations: [
//       new VueIntegration({
//         Vue,
//         tracing: true,
//       }),
//       new Integrations.BrowserTracing(),
//     ],
//     // We recommend adjusting this value in production, or using tracesSampler
//     // for finer control
//     tracesSampleRate: 1.0,
//   });
// }

Vue.use(VModal);
Vue.use(VueWindowSize, {
  delay: 200,
});
Vue.use(VueMeta);
Vue.use(vClickOutside);
Vue.use(LoadScript);
Vue.use(Notifications);

Vue.config.productionTip = false;

Vue.prototype.$ga = gaEventEmitter;

Vue.prototype.$window = window;

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored;
  next();
};
router.beforeEach(waitForStorageToBeReady);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
